import React, { Component } from "react";
import {
  Form,
  FormGroup,
  Label,
  Col,
  Button,
  Row,
  Popover,
  PopoverHeader,
  PopoverBody,
  Alert,
} from "reactstrap";
import {
  chartStep,
  emptyKPIRecords,
  getEmptyKPIRecords,
  kpisMapping,
  diversityCategories,
  genderOptions,
  diversityTypes,
  diversityFocusOptions,
  kpiBasedType,
} from "../../../../utils/constants";
import {
  getAgreegateKpisData,
  getBenchmarkData,
} from "../../../../utils/filterKpisData";
import ChartPreview from "../ChartPreview/ChartPreview";
import { deepClone } from "../../../../utils/copyObject";
import KPIRecord from "../KPIRecord/KPIRecord";
import Tooltip from "../../../../components/UI/TooltipIcon/TooptipIcon";
import ErrorMessage from "../../../../components/Message/ErrorMessage/ErrorMessage";
import { getFlatDataFromTree } from "react-sortable-tree";
import Select from "react-select";
// import Checkbox from 'rc-checkbox';
import DatePicker from "react-datepicker";
import moment from "moment";
import pick from "lodash/pick";
import findIndex from "lodash/findIndex";
import Toggle from "react-toggle";
import "../Component.css";
import "rc-checkbox/assets/index.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-select/dist/react-select.css";
import "react-toggle/style.css";
import "rc-checkbox/assets/index.css";
import LockUnlockChartComponent from "../../../../components/LockUnlockChart/LockUnlockChartComponent";
// handleKpiSelection

export default class ChartDetails extends Component {
  // var length =  this.props.chartDetails.kpiData&&this.props.chartDetails.kpiData.length?
  // this.props.chartDetails.kpiData.length: 3

  constructor(props) {
    super(props);

    this.state = {
      startDate:
        this.props.chartDetails.startDate !== "" &&
        this.props.chartDetails.startDate !== null
          ? moment.utc(this.props.chartDetails.startDate)
          : null,
      endDate:
        this.props.chartDetails.endDate !== "" &&
        this.props.chartDetails.endDate !== null
          ? moment.utc(this.props.chartDetails.endDate)
          : null,
      useLatestDataAvailable: this.props.chartDetails.useLatestDataAvailable,
      yAxisFormat: this.props.chartDetails.yAxisFormat,
      selectedKPI: {},
      dataAvailablePopoverOpen: false,
      flatHierarchy: getFlatDataFromTree({
        treeData: this.props.user.organizationId.staticHierarchy,
        getNodeKey: ({ node }) => node.id,
        ignoreCollapsed: false,
      }).map((node) => {
        return {
          ...node,
          label: node.node.title,
          value: node.node.officeKey
            ? node.node.officeKey
            : node.path.join("#"),
          archivedOfficeNames: node.node.archivedOfficeNames
            ? node.node.archivedOfficeNames.map((e) => e.title)
            : [],
        };
      }),
      kpiRecords:
        this.props.chartDetails.kpiRecords.length > 0
          ? this.props.chartDetails.kpiRecords
          : deepClone(
              getEmptyKPIRecords(
                this.props.chartDetails.kpiData &&
                  this.props.chartDetails.kpiData.length
                  ? this.props.chartDetails.kpiData.length
                  : 3
              )
            ),
      kpiRecordsPlus: [],
      chartStatusPopoverOpen:false,
      kpiType: this.props.chartDetails.kpiType || this.props.kpiType,
      kpiData: this.props.chartDetails.kpiData || [],
      benchmarkData: this.props.chartDetails.benchmarkData,
      orgMapping: this.props.orgMapping,
      showPreviewBtn: false,
      selectedOffice:
        this.props.chartDetails.selectedOffice == null ||
        this.props.chartDetails.selectedOffice == undefined
          ? ""
          : this.props.chartDetails.selectedOffice,
      error: false,
      errorMessage: "",
      isCopied: this.props.chartDetails.isCopied
        ? this.props.chartDetails.isCopied
        : null,
      previewOrContinue: false,
      emptyStateImage: this.props.emptyStateImage,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setSelectedKpiAgreegateData(nextProps);
  }

  // Handle condtion to show preselect kpis if case of edit chart
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.previewOrContinue !== prevProps.previewOrContinue) {
      this.setState({
        emptyState: this.props.previewOrContinue,
        previewOrContinue: this.props.previewOrContinue,
      });
    }
  }

  componentDidMount() {
    this.setSelectedKpiAgreegateData(this.props);
    // console.log(this.state.emptyStateImage)
    window.scrollTo(0, 0);

    // const datePickerEffectiveDate = document.getElementsByClassName('react-datepicker__input-container')[0];
    // datePickerEffectiveDate.childNodes[0].setAttribute('readOnly', true);
    // const datePickerEndDate = document.getElementsByClassName('react-datepicker__input-container')[1];
    // datePickerEndDate.childNodes[0].setAttribute('readOnly', true);
  }

  getParameterId = (valueId, options) => {
    // console.log(valueId,'---v----',options)
    if (valueId) {
      let foundValue = options.filter((val) => valueId._id === val.id);
      // console.log('Value Found-----',foundValue)
      if (foundValue.length > 0) {
        return foundValue[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  // Set selected kpi agreegate on edit chart
  setSelectedKpiAgreegateData = (props) => {
    // console.log(this.props)
    let { chartDetails, kpiList, orgMapping } = props;
    let {
      gender,
      ethnicityOptions,
      sexualOrientationOptions,
      disabilityOptions,
      veteranOptions,
      religionOptions,
      occupationOptions,
      seniorityOptions,
      performanceOptions,
      separationOptions,
    } = orgMapping;
    let {
      kpiAgreegateData,
      kpiData,
      benchmarkData,
      selectedBenchmark,
    } = chartDetails;
    let {
      kpiRecords,
      kpiType,
      startDate,
      endDate,
      useLatestDataAvailable,
    } = this.state;
    console.log("kkmmm",kpiData)
    let occupation = null;
    let sexualOrientation = null;
    let seniority = null;
    let ethnicity = null;
    let disability = null;
    let veteran = null;
    let religion = null;
    let selectedGender = null;
    let performance = null;
    let separation = null;
    let selectedLocation = { country: null, state: null };
    let selectedKpiRecords = kpiRecords.filter((kpi) => kpi.selected);
    // console.log(kpiData)
    if (
      selectedKpiRecords.length == 0 &&
      kpiData &&
      kpiData.length > 0 &&
      orgMapping &&
      gender && gender.data
    ) {
      kpiRecords = kpiRecords.map((kpiRecord, index) => {
        if (kpiData[index]) {
          // console.log('kpiData---', kpiData[index])
          let {
            kpiId,
            occupationId,
            sexualOrientationId,
            ethnicityId,
            religionId,
            veteranId,
            disabilityId,
            seniorityId,
            diversityType,
            ageStart,
            ageEnd,
          } = { ...kpiData[index] };
          let isTenure = false;

          const findDocsTenureExist = kpiData[index].score && kpiData[index].score.find(x => x.avgTenure && x.avgTenure !=null);

          if(findDocsTenureExist){
            isTenure = true
          }
          // let {ethnicityId } = kpiData[index]
          let selectedKPI = {
            id: kpiId._id,
            name: kpiId.name,
            code: kpiId.code,
            description: kpiId.description,
            refObject:kpiId
          };
          let filteredGender = kpiRecord.genderOptions.filter(
            (gender) => gender.id === diversityType
          );
          if (filteredGender.length > 0) {
            // console.log(diversityType)
            selectedGender =
              diversityType &&
              diversityType !== "null" &&
              diversityType !== null
                ? filteredGender[0]
                : null;
          } else {
            selectedGender = null;
          }

          let activeGenders = kpisMapping[selectedKPI.code]["activeGenders"];

          if (kpisMapping[kpiId.code]["gender"]) {
            // kpisMapping
            let genderOptions = kpiRecord.genderOptions;
            kpiRecord.genderOptions = genderOptions.map((gender) => {
              let gendersInGenderMapping = orgMapping.gender.data.filter(
                (mappedGender) => mappedGender.key === gender.id
              );
              if (
                activeGenders.indexOf(gender.name) !== -1 &&
                orgMapping.gender &&
                gendersInGenderMapping.length > 0
              ) {
                delete gender.disabled;
                return { ...gender };
              } else {
                return { ...gender, disabled: true };
              }
            });
          } else {
            if (
              !kpiRecord.enableGender &&
              activeGenders &&
              activeGenders.length == 1
            ) {
              selectedGender =
                activeGenders[0] == "All"
                  ? null
                  : { id: activeGenders[0], name: activeGenders[0] };
              kpiRecord.gender = selectedGender;
            } else {
              selectedGender =
                activeGenders[0] == "All"
                  ? null
                  : { id: activeGenders[0], name: activeGenders[0] };
              kpiRecord.gender = selectedGender;
            }
          }

          // console.log('seee---', selectedGender)
          if (occupationId) {
            let foundOccupation = occupationOptions.filter(
              (occupation) => occupationId._id === occupation.id
            );
            if (foundOccupation.length > 0) {
              occupation = foundOccupation[0];
            } else {
              occupation = null;
            }
          } else {
            occupation = null;
          }

          if (seniorityId) {
            let foundSeniority = seniorityOptions.filter(
              (seniority) => seniorityId._id === seniority.id
            );
            if (foundSeniority.length > 0) {
              seniority = foundSeniority[0];
            } else {
              seniority = null;
            }
          } else {
            seniority = null;
          }

          if (kpisMapping[selectedKPI.code].performance) {
            let { performanceOptions } = orgMapping;
            let perfomanceKey = kpisMapping[selectedKPI.code].performanceKey;
            let performanceMapping = performanceOptions
              ? performanceOptions
              : [];
            let matchedPerfomance = performanceMapping.filter(
              (performance) => performance.name === perfomanceKey
            );
            if (matchedPerfomance.length > 0) {
              performance = matchedPerfomance[0];
            }
          }

          if (kpisMapping[selectedKPI.code].separation) {
            let { separationOptions } = orgMapping;
            let separationKey = kpisMapping[selectedKPI.code].separationKey;
            let separationMapping = separationOptions ? separationOptions : [];
            let matchedSeparation = separationMapping.filter(
              (separation) => separation.name === separationKey
            );
            if (matchedSeparation.length > 0) {
              separation = matchedSeparation[0];
            }
          }

          ethnicity = this.getParameterId(ethnicityId, ethnicityOptions);
          veteran = this.getParameterId(veteranId, veteranOptions);
          religion = this.getParameterId(religionId, religionOptions);
          disability = this.getParameterId(disabilityId, disabilityOptions);
          sexualOrientation = this.getParameterId(
            sexualOrientationId,
            sexualOrientationOptions
          );

          if (
            kpiData[index].location &&
            kpiData[index].location.key !== "" &&
            kpiData[index].location.values &&
            kpiData[index].location.values.length > 0
          ) {
            let { values } = kpiData[index].location;
            selectedLocation = {
              country: { name: "United States", code: "US" },
              state: { id: values[0], name: values[1] },
            };
          }

          // console.log('eth---', ethnicity)

          return {
            tenure:isTenure,
            ...kpiRecord,
            gender: selectedGender,
            ageStart,
            ageEnd,
            selectedKPI,
            occupation,
            selectedLocation,
            sexualOrientation,
            disability,
            veteran,
            seniority,
            performance,
            separation,
            ethnicity,
            religion,
            selected: true,
            enableGender: kpisMapping[kpiId.code]["gender"]
              ? kpisMapping[kpiId.code]["gender"]
              : false,
            enableOccupation: kpisMapping[kpiId.code]["occupation"]
              ? kpisMapping[kpiId.code]["occupation"]
              : false,
            enableEthnicity: kpisMapping[kpiId.code]["ethnicity"]
              ? kpisMapping[kpiId.code]["ethnicity"]
              : false,
            enableSexualOrientation: kpisMapping[kpiId.code][
              "sexualOrientation"
            ]
              ? kpisMapping[kpiId.code]["sexualOrientation"]
              : false,
            enableVeteran: kpisMapping[kpiId.code]["veteran"]
              ? kpisMapping[kpiId.code]["veteran"]
              : false,
            enableDisability: kpisMapping[kpiId.code]["disability"]
              ? kpisMapping[kpiId.code]["disability"]
              : false,
            enableReligion: kpisMapping[kpiId.code]["religion"]
              ? kpisMapping[kpiId.code]["religion"]
              : false,
            enableSeniority: kpisMapping[kpiId.code]["seniority"]
              ? kpisMapping[kpiId.code]["seniority"]
              : false,
          };
        } else {
          return kpiRecord;
        }
      });
    }

    if (kpiAgreegateData && kpiAgreegateData.length > 0) {
      let formattedKpiData = getAgreegateKpisData({
        kpiRecords,
        kpiAgreegateData,
        kpiType,
        startDate,
        endDate,
        useLatestDataAvailable,
      });
      if (selectedBenchmark !== null)
        benchmarkData = getBenchmarkData(
          { kpiAgreegateData, selectedBenchmark },
          false,
          { startDate, endDate, useLatestDataAvailable }
        );
      this.setState({
        kpiRecords,
        kpiData: formattedKpiData,
        benchmarkData,
        orgMapping,
      });
    } else {
      this.setState({ kpiRecords, orgMapping });
    }
  };

  handleAgreegateKpiChange = (selectedAgreegatedKpi) => {
    const { selectedAgreegatedKpis } = this.state;
    // console.log("kpi----", selectedAgreegatedKpis)
    const i = findIndex(selectedAgreegatedKpis, (option) => {
      return option._id === selectedAgreegatedKpi._id;
    });
    if (i > -1) {
      selectedAgreegatedKpis.splice(i, 1);
    } else {
      if (selectedAgreegatedKpis.length < 3) {
        selectedAgreegatedKpis.push(selectedAgreegatedKpi);
      }
    }
    this.setState({
      selectedAgreegatedKpis: selectedAgreegatedKpis,
    });
  };

  handleStartDateChange = (date) => {
    // console.log(date)
    if (this.state.endDate !== null && date > this.state.endDate) {
      this.setState({
        startDate: this.state.endDate,
        error: false,
      });
    } else {
      this.setState({
        startDate: date,
        error: false,
      });
    }
  };

  handleEndDateChange = (date) => {
    if (this.state.startDate != null && date < this.state.startDate) {
      this.setState({
        endDate: this.state.startDate,
        error: false,
      });
    } else {
      this.setState({
        endDate: date,
        error: false,
      });
    }
  };

  validateChartDetails = (type) => {
    this.setState({ error: false, errorMessage: "" });
    let {
      startDate,
      endDate,
      useLatestDataAvailable,
      kpiRecords,
      kpiType,
      kpiData,
      selectedOffice,
      flatHierarchy,
      yAxisFormat,
    } = { ...this.state };
    // console.log(this.state)
    if (selectedOffice === "") {
      selectedOffice = this.findOfficeChart();
    }

    // let selectedKpiRecords = kpiRecords.filter(kpiRecord => kpiRecord.selected);
    let selectedKPIRecords = kpiRecords.filter(
      (kpi) => kpi.selectedKPI !== null
    );

    if (selectedKPIRecords.length === 0) {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage:
          "Please select at least one Key Performance Indicator (KPI).",
      });
      return;
    }

    if (selectedOffice == "") {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage: "Please select an office or department.",
      });
      return;
    }

    if (selectedKPIRecords) {
      for (var x = 0; x < selectedKPIRecords.length; x++) {
        let obj = selectedKPIRecords[x];
        let { kpiType } = kpisMapping[obj.selectedKPI.code];

        if (
          obj.selectedKPI.code !== "HRT-1" &&
          obj.selectedKPI.code !== "HRT-2" &&
          obj.selectedKPI.code !== "HRT-4" &&
          kpiType !== "SURVEY_BASED" &&
          obj.kpiType !== "SURVEY_BASED"
        ) {
          let isRecordErr = diversityTypes.some((item) => {
            return obj[item] != undefined && obj[item] != null ? true : false;
          });

          if (!isRecordErr) {
            window.scrollTo(0, 0);
            this.setState({
              error: true,
              errorMessage: `All KPIs must contain at least one of the following: ${diversityFocusOptions.map(
                (e) => ` ${e.name}`
              )}`,
            });
            return;
          }
        }
      }
    }

    if (selectedKPIRecords.length > 1) {
      for (var x = 0; x < selectedKPIRecords.length; x++) {
        if (
          JSON.stringify(selectedKPIRecords[x]) ===
          JSON.stringify(selectedKPIRecords[x + 1])
        ) {
          window.scrollTo(0, 0);
          this.setState({
            error: true,
            errorMessage:
              "Please make sure that the KPIs you select are unique",
          });
          return;
        }
      }
    }

    if (startDate === null && endDate === null) {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage: "Please select start date and end date.",
      });
      return;
    }
    if (startDate && startDate != "") {
      startDate = startDate.format("YYYY-MM-DD") + "T00:00:00.000Z";
    } else {
      window.scrollTo(0, 0);
      this.setState({ error: true, errorMessage: "Please select start date." });
      return;
    }
    if (useLatestDataAvailable === false) {
      if (endDate && endDate != "") {
        endDate = endDate.format("YYYY-MM-DD") + "T23:59:59.000Z";
      } else {
        window.scrollTo(0, 0);
        this.setState({ error: true, errorMessage: "Please select end date." });
        return;
      }
    }

    if (type == "preview") {
      this.setState({ error: false, previewOrContinue: true });
      this.props.previewChart({
        selectedKPIRecords,
        kpiType,
        startDate,
        endDate,
        useLatestDataAvailable,
        selectedOffice,
        yAxisFormat,
      });
    } else {
      this.setState({ error: false, previewOrContinue: true });
      this.props.onCompleted({
        startDate,
        endDate,
        useLatestDataAvailable,
        kpiRecords,
        kpiType,
        kpiData,
        selectedOffice,
        yAxisFormat,
      });
    }
  };

  handleUseLatestDateChange = () => {
    this.setState({
      useLatestDataAvailable: !this.state.useLatestDataAvailable,
      endDate: null,
      error: false,
    });
  };

  toggleLatestDataAvailablePopover = () => {
    this.setState({
      dataAvailablePopoverOpen: !this.state.dataAvailablePopoverOpen,
    });
  };

  toggleChartStatusPopover = () => {
    this.setState({
      chartStatusPopoverOpen: !this.state.chartStatusPopoverOpen,
    });
  };

  handleKpiSelection = (selectedKPI, index) => {
    let { kpiRecords, kpiRecordsPlus, kpiType } = { ...this.state };
    // kpiRecords= [...kpiRecords, ...kpiRecordsPlus]
    let { orgMapping } = { ...this.props };
    let showPreviewBtn = false;
    if (selectedKPI === null) {
      kpiRecords[index].selected = false;
      kpiRecords[index].ageStart = null;
      kpiRecords[index].ageEnd = null;
      kpiRecords[index].gender = null;
      kpiRecords[index].location = null;
      kpiRecords[index].occupation = null;
      kpiRecords[index].sexualOrientation = null;
      kpiRecords[index].veteran = null;
      kpiRecords[index].religion = null;
      kpiRecords[index].disability = null;
      kpiRecords[index].ethnicity = null;
      kpiRecords[index].senoirity = null;
      kpiRecords[index].selectedKPI = null;
      kpiRecords[index].kpiType = "";
      kpiRecords[index].genderOptions = kpiRecords[index].genderOptions.map(
        (gender) => {
          delete gender.disabled;
          return { ...gender };
        }
      );
      kpiRecords[index].performance = null;
      kpiRecords[index].separation = null;
      let selectedKpiRecords = kpiRecords.filter(
        (kpi) => kpi.selectedKPI !== null
      );
      if (selectedKpiRecords.length > 0) {
        showPreviewBtn = true;
      } else kpiType = "";
    } else {
      kpiRecords[index].selected = true;
      kpiRecords[index].enableGender =
        kpisMapping[selectedKPI.code] && kpisMapping[selectedKPI.code]["gender"]
          ? kpisMapping[selectedKPI.code]["gender"]
          : false;
      kpiRecords[index].enableEthnicity =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["ethnicity"]
          ? kpisMapping[selectedKPI.code]["ethnicity"]
          : false;
      kpiRecords[index].enableVeteran =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["veteran"]
          ? kpisMapping[selectedKPI.code]["veteran"]
          : false;
      kpiRecords[index].enableSexualOrientation =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["sexualOrientation"]
          ? kpisMapping[selectedKPI.code]["sexualOrientation"]
          : false;
      kpiRecords[index].enableReligion =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["religion"]
          ? kpisMapping[selectedKPI.code]["religion"]
          : false;
      kpiRecords[index].enableDisability =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["disability"]
          ? kpisMapping[selectedKPI.code]["disability"]
          : false;
      kpiRecords[index].enableOccupation =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["occupation"]
          ? kpisMapping[selectedKPI.code]["occupation"]
          : false;
      kpiRecords[index].enableSeniority =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["seniority"]
          ? kpisMapping[selectedKPI.code]["seniority"]
          : false;
      kpiRecords[index].kpiType =
        kpisMapping[selectedKPI.code] &&
        kpisMapping[selectedKPI.code]["kpiType"]
          ? kpisMapping[selectedKPI.code]["kpiType"]
          : "";
      kpiRecords[index].selectedKPI = selectedKPI;
      // kpiRecords[index].ageStart
      kpiType = kpiRecords[index].kpiType;

      let activeGenders = kpisMapping[selectedKPI.code]["activeGenders"];

      if (kpiRecords[index].enableGender) {
        kpiRecords[index].gender = true;
        let genderOptions = kpiRecords[index].genderOptions;
        kpiRecords[index].genderOptions = genderOptions.map((gender) => {
          let gendersInGenderMapping = orgMapping.gender.data.filter(
            (mappedGender) => mappedGender.key === gender.id
          );
          if (
            activeGenders.indexOf(gender.name) !== -1 &&
            orgMapping.gender &&
            gendersInGenderMapping.length > 0
          ) {
            delete gender.disabled;

            return { ...gender };
          } else {
            return { ...gender, disabled: true };
          }
        });
      } else {
        if (
          !kpiRecords[index].enableGender &&
          activeGenders &&
          activeGenders.length == 1
        ) {
          kpiRecords[index].gender =
            activeGenders[0] == "All"
              ? null
              : { id: activeGenders[0], name: activeGenders[0] };
        } else {
          kpiRecords[index].gender = activeGenders[0] == "All" ? null : true;
        }
      }

      showPreviewBtn = true;
      if (kpisMapping[selectedKPI.code].performance) {
        let { performanceOptions } = orgMapping;
        let perfomanceKey = kpisMapping[selectedKPI.code].performanceKey;
        let performanceMapping = performanceOptions ? performanceOptions : [];
        // console.log(performanceMapping)
        let matchedPerfomance = performanceMapping.filter(
          (performance) => performance.name === perfomanceKey
        );
        if (matchedPerfomance.length > 0) {
          kpiRecords[index].performance = matchedPerfomance[0];
        }
      }
      if (kpisMapping[selectedKPI.code].separation) {
        let { separationOptions } = orgMapping;
        let separationKey = kpisMapping[selectedKPI.code].separationKey;
        let separationMapping = separationOptions ? separationOptions : [];
        let matchedSeparation = separationMapping.filter(
          (separation) => separation.name === separationKey
        );
        if (matchedSeparation.length > 0) {
          kpiRecords[index].separation = matchedSeparation[0];
        }
      }
    }
    // console.log(kpiRecords)

    this.setState({
      kpiRecords: kpiRecords,
      kpiType,
      showPreviewBtn,
      selectedKPI,
      error: false,
    });
  };

  handleGenderSelection = (gender, index) => {
    let { kpiRecords } = { ...this.state };
    kpiRecords[index].gender = gender;
    this.setState({ kpiRecords: kpiRecords });
  };

  handleEthnicitySelection = (selectedEthnicity, index) => {
    // console.log(selectedEthnicity)
    let { kpiRecords } = { ...this.state };
    kpiRecords[index].ethnicity = selectedEthnicity;
    this.setState({ kpiRecords: kpiRecords });
  };

  handleFieldSelection = (selectedValue, field, index) => {
    // console.log(selectedValue, field, index)
    let { kpiRecords } = { ...this.state };
    // console.log(kpiRecords)
    kpiRecords[index][field] = selectedValue;
    console.log(' kpiRecords[index] FIELD---- ',  field)
    console.log(' kpiRecords[index] ---- ',  kpiRecords[index][field])
    this.setState({ kpiRecords: kpiRecords });
  };

  handleCountrySelection = (country, index) => {
    let { kpiRecords } = { ...this.state };
    // console.log('kpiRec 304 ChartDeee---', kpiRecords)
    let { state } = kpiRecords[index].selectedLocation;
    if (country !== null && state !== null && country.code === "US") {
      kpiRecords[index].selectedLocation = { country, state };
    } else if (country.code === null) {
      kpiRecords[index].selectedLocation.country = null;
    } else {
      kpiRecords[index].selectedLocation = { country, state: null };
    }
    // console.log('kpiRec 311 ChartDeee---', kpiRecords)

    this.setState({ kpiRecords: kpiRecords });
  };

  handleStatesSelection = (selectedState, index) => {
    let { kpiRecords } = { ...this.state };
    let { country } = kpiRecords[index].selectedLocation;
    kpiRecords[index].selectedLocation = { country, state: selectedState };
    this.setState({ kpiRecords: kpiRecords });
  };

  handleOccupationSelection = (selectedOccupation, index) => {
    let { kpiRecords } = { ...this.state };
    kpiRecords[index].occupation = selectedOccupation;
    this.setState({ kpiRecords: kpiRecords });
  };

  handleSenoiritySelection = (selectedSeniority, index) => {
    let { kpiRecords } = { ...this.state };
    kpiRecords[index].seniority = selectedSeniority;
    this.setState({ kpiRecords: kpiRecords });
  };

  // Trigger datepicker on calender icon
  openDatePicker = (id) => {
    document.getElementById(id).click();
  };

  previewChart = () => {
    let {
      kpiType,
      kpiRecords,
      startDate,
      endDate,
      useLatestDataAvailable,
      selectedOffice,
      yAxisFormat,
    } = this.state;

    if (startDate === null && endDate === null) {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage: "Please select start date and end date.",
      });
      return;
    }
    if (startDate === null) {
      window.scrollTo(0, 0);
      this.setState({ error: true, errorMessage: "Please select start date." });
      return;
    }

    if (selectedOffice === null) {
      window.scrollTo(0, 0);
      this.setState({
        error: true,
        errorMessage: "Please select an office or department.",
      });
      return;
    }

    if (useLatestDataAvailable === false) {
      if (endDate && endDate !== "" && endDate !== null) {
        endDate = endDate.format("YYYY-MM-DD") + "T23:59:59.000Z";
      } else {
        window.scrollTo(0, 0);
        this.setState({ error: true, errorMessage: "Please select end date." });
        return;
      }
    }

    //  console.log('KPI Records');
    let selectedKPIRecords = kpiRecords.filter(
      (kpi) => kpi.selectedKPI !== null
    );
    let selectedGenderKPIRecords = selectedKPIRecords.filter(
      (kpi) => kpi.gender !== null
    );
    //  if(selectedKPIRecords.length !== selectedGenderKPIRecords.length && kpiType === kpiBasedType.empDataBased){
    //    window.scrollTo(0, 0);
    //    this.setState({error: true, errorMessage: 'Please select gender for all Key Performance Indicators (KPI).'});
    //    return;
    //  }
    //  let selectedKpiList = selectedKPIRecords.map(kpiRecord => {
    //    return {code: kpiRecord.selectedKPI.code, occupationId: kpiRecord.occupation.id, senorityId: kpiRecord.seniority.id}
    //  })
    if (startDate !== null) {
      startDate = startDate.format("YYYY-MM-DD") + "T00:00:00.000Z";
    }
    // if(endDate!==null) {
    //   endDate = endDate.format('YYYY-MM-DD') + 'T23:59:59.000Z';
    // }
    // console.log(selectedKPIRecords)

    this.props.previewChart({
      selectedKPIRecords,
      kpiType,
      startDate,
      endDate,
      useLatestDataAvailable,
      selectedOffice,
      yAxisFormat,
    });
    this.setState({ error: false, previewOrContinue: true });
  };

  addRecord = () => {
    // let{kpiRecords}=this.state
    // if(kpiRecords.length<){
    let { kpiRecords, kpiRecordsPlus } = this.state;
    let newObject = { ...kpiRecords[kpiRecords.length - 1] };
    newObject.label = kpiRecords.length + kpiRecordsPlus.length + 1;
    // newObject
    // kpiRecordsPlus.label
    // kpiRecordsPlus.push(newObject)
    kpiRecords.push(newObject);
    this.setState({ kpiRecords });
    // }
  };

  onOfficeSelect = (office) => {
    console.log("office --- ", office);
    if (office) {
      this.setState({ selectedOffice: { ...office } });
    } else {
      this.setState({ selectedOffice: null });
    }
  };

  yAxisFormat = (val) => {
    this.setState({ yAxisFormat: val });
  };

  findOfficeChart = () => {
    let { chartDetails } = this.props;
    let { officeId } = chartDetails;
    let { flatHierarchy, selectedOffice } = this.state;

    if (
      selectedOffice != "" &&
      selectedOffice !== null &&
      selectedOffice != undefined
    ) {
      console.log("selected---", selectedOffice);
      let res = flatHierarchy.find((el) => el.value === selectedOffice.value);
      console.log("res---", res);
      return flatHierarchy.find((el) => el.value === selectedOffice.value);
    } else if (officeId) {
      return flatHierarchy.find(
        (el) =>
          el.label === officeId.name ||
          (el.archivedOfficeNames &&
            el.archivedOfficeNames.indexOf(officeId.name) > -1)
      );
    } else {
      return "";
    }
  };

  render() {
    let {
      isCopied,
      selectedOffice,
      flatHierarchy,
      startDate,
      endDate,
      selectedAgreegatedKpis,
      kpiAgreegateAvailable,
      useLatestDataAvailable,
      kpiRecords,
      kpiType,
      showPreviewBtn,
      kpiData,
      benchmarkData,
      kpiRecordsPlus,
    } = { ...this.state };
    let {
      kpiAgreegateData,
      selectedBenchmark,
      privacy,
    } = this.props.chartDetails;
    let chartName;

    let {
      kpiList,
      orgMapping,
      user,
      industriesList,
      isChartLocked,
    } = this.props;

    console.log(this.props);
    let alert = null;
    let continueBtnOffset = 8;
    // console.log('records---', kpiRecords)
    if (this.state.error) {
      alert = <ErrorMessage message={this.state.errorMessage} />;
    }

    if (kpiType && kpiType !== "undefined") {
      // console.log(kpiList, kpiType)
      kpiList = kpiList.filter(
        (kpi) =>
          kpisMapping[kpi.code]["kpiType"] &&
          kpisMapping[kpi.code]["kpiType"] === kpiType
      );
    }

    let filteredKpiRecords = kpiRecords.filter((kpi) => kpi.selected);
    if (filteredKpiRecords.length > 0) {
      showPreviewBtn = true;
    }
    continueBtnOffset = showPreviewBtn ? 0 : 8;

    let dataInDateRangeAvailable = getAgreegateKpisData({
      startDate,
      endDate,
      selectedAgreegatedKpis,
      useLatestDataAvailable,
    });
    return (
      <Form>
        {alert}
        <div>
         
          <FormGroup className="mt25" row>
            <Col sm={2} className="text-right">
              <div className="text-right chartLabel">
                Select Office or Department
              </div>
            </Col>
            <Col sm={6} md={6} className="align-self-center">
              <Select
                name="office-select"
                placeholder={"Select Office or Department..."}
                value={
                  this.findOfficeChart()
                  // selectedOffice!==null?
                  // flatHierarchy.find(el => el.value===selectedOffice.value) :
                  // ""
                }
                isOpen={true}
                options={flatHierarchy}
                isClearable={false}
                onChange={(itm) => this.onOfficeSelect(itm)}
                disabled={isChartLocked}
              />
            </Col>
          </FormGroup>
        </div> 

        <FormGroup className="mt25" row>
            <Col sm={2} className="text-right">
                <div className="text-right chartLabel">
                  Chart Status 
                      <span
                      id="chart-status-popover"
                      className=""
                      onClick={this.toggleChartStatusPopover}
                    >
                      <Tooltip />
                    </span>
                    <Popover
                      placement="right"
                      isOpen={this.state.chartStatusPopoverOpen}
                      target="chart-status-popover"
                      toggle={this.toggleChartStatusPopover}
                    >
                      <PopoverHeader className="popover-header-tooltip">
                        Chart Status
                      </PopoverHeader>
                      <PopoverBody className="popover-body-tooltip">
                        <span className="fw600">Active</span> means this chart can be updated as new data is uploaded to the system and/or as hierarchy changes are made in your organization. <br/><br/> <span className="fw600">Locked</span> means this chart’s data will no longer updated by new data or hierarchy changes.
                      </PopoverBody>
                    </Popover>
                </div>
            </Col>

            <Col sm={3} md={3} className="align-self-center">
                  <LockUnlockChartComponent
                      chart={this.props.copyChart}
                      updateChart={(data) => {
                        this.props.updateLockToggle(data);
                      }}
                      user={{ profile: this.props.user }}
                      renderIntoAlert
                      alertMessage="The chart has been locked. if you would like to unlock it,
                      please deselect the disable update option below"
                    />
            </Col>
        </FormGroup>

        {kpiRecords.map((kpi, index) => {
          return (
            <div key={index} className={index > 0 ? "mt15" : ""}>
              <KPIRecord
                kpi={kpi}
                isCopied={isCopied}
                label={kpi.label}
                index={index}
                kpiList={kpiList}
                ageRange={this.props.ageRange}
                orgMapping={orgMapping}
                onKpiSelect={this.handleKpiSelection}
                onGenderSelect={this.handleGenderSelection}
                onEthnicitySelect={this.handleEthnicitySelection}
                onFieldSelect={this.handleFieldSelection}
                onCountrySelect={this.handleCountrySelection}
                onStatesSelect={this.handleStatesSelection}
                onOccupationSelect={this.handleOccupationSelection}
                onSenoiritySelect={this.handleSenoiritySelection}
                kpiType={kpiType}
                isOwner={this.props.isOwner}
                isChartLocked={isChartLocked}
              />
            </div>
          );
        })}
        {kpiRecords && kpiRecords.length < 10 ? (
          <Col sm={3} md={3} className="align-self-center">
            <Button
              className="mtb10 float-right continueBtn ml10 w100 btn btn-secondary"
              onClick={() => this.addRecord()}
              disabled={isChartLocked}
            >
              Add More KPIs
            </Button>
          </Col>
        ) : (
          <p
            style={{
              textAlign: "center",
              fontSize: "20px",
              color: "#54555F !important",
            }}
          >
            Max number of KPIs reached.
          </p>
        )}

        {kpiRecordsPlus.map((kpi, index) => {
          let idx = kpiRecords.length + index;
          return (
            <div key={idx} className={idx > 0 ? "mt15" : ""}>
              <KPIRecord
                kpi={kpi}
                isCopied={isCopied}
                label={kpi.label}
                index={idx}
                kpiList={kpiList}
                ageRange={this.props.ageRange}
                orgMapping={orgMapping}
                onKpiSelect={this.handleKpiSelection}
                onGenderSelect={this.handleGenderSelection}
                onEthnicitySelect={this.handleEthnicitySelection}
                onFieldSelect={this.handleFieldSelection}
                onCountrySelect={this.handleCountrySelection}
                onStatesSelect={this.handleStatesSelection}
                onOccupationSelect={this.handleOccupationSelection}
                onSenoiritySelect={this.handleSenoiritySelection}
                kpiType={kpiType}
                isOwner={this.props.isOwner}
                isChartLocked={isChartLocked}
              />
            </div>
          );
        })}

        <FormGroup className="mt25" row>
          <Col sm={2} className="text-right">
            <div className="text-right chartLabel">Start Date</div>
          </Col>
          <Col sm={3} md={3} className="align-self-center">
            <div className="inner-addon right-addon">
              <span
                className="tool-start-date flaticon-calendar"
                onClick={() => this.openDatePicker("startDatePicker")}
              />
              <DatePicker
                id="startDatePicker"
                placeholderText="Select start date"
                className="input-custom-date form-control"
                selectsStart
                showYearDropdown
                selected={this.state.startDate}
                onChange={this.handleStartDateChange}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                maxDate={moment(new Date())}
                disabled={isChartLocked}
              />
            </div>
          </Col>
        </FormGroup>
        <FormGroup className="mt25" row>
          <Col sm={2} className="text-right">
            <div className="text-right chartLabel">End Date</div>
          </Col>
          <Col sm={3} className="align-self-center">
            <div className="inner-addon right-addon">
              <span className="tool-end-date">
                <span
                  className="flaticon-calendar"
                  onClick={() => this.openDatePicker("endDatePicker")}
                />
              </span>
              <DatePicker
                id="endDatePicker"
                placeholderText="Select end date"
                className="input-custom-date form-control"
                selectsEnd
                showYearDropdown
                selected={this.state.endDate}
                onChange={this.handleEndDateChange}
                startDate={this.state.startDate ? moment.utc(this.state.startDate):null}
                endDate={this.state.endDate}
                disabled={useLatestDataAvailable || !this.state.startDate || isChartLocked}
                minDate={this.state.startDate}
                maxDate={moment(new Date())}
              />
            </div>
          </Col>
          <Col className="d-flex pl0">
            <div className="d-flex align-items-center">
              <span className="or-latest-data">or</span>
              <span className="ml10">
                <Toggle
                  defaultChecked={useLatestDataAvailable}
                  icons={false}
                  onChange={this.handleUseLatestDateChange}
                  disabled={isChartLocked}
                />
              </span>
              <span className="ml10 latest-data-available">
                latest data available
              </span>
              <span
                id="latest-data-available-popover"
                className="ml10"
                onClick={this.toggleLatestDataAvailablePopover}
              >
                <Tooltip />
              </span>
              <Popover
                placement="right"
                isOpen={this.state.dataAvailablePopoverOpen}
                target="latest-data-available-popover"
                toggle={this.toggleLatestDataAvailablePopover}
              >
                <PopoverHeader className="popover-header-tooltip">
                  Latest Data Available
                </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  If you select "latest data available" the time series will
                  include all data from your start date to the latest date that
                  data is available for this KPI. NOTE this chart will be
                  updated automatically when new data is available.
                </PopoverBody>
              </Popover>
            </div>
          </Col>
        </FormGroup>
        <FormGroup className="mt30" row>
          <Col sm={{ size: 2, offset: 6 }} md={{ size: 2, offset: 6 }}>
            {showPreviewBtn && !isChartLocked && (
              <Button
                className="float-right previewBtn w100"
                onClick={() => this.validateChartDetails("preview")}
              >
                <span className="cancelBtnTxt">
                  <span className="mr10 flaticon-vision" /> Preview
                </span>
              </Button>
            )}
          </Col>
          <Col
            sm={{ size: 3, offset: continueBtnOffset }}
            md={{ size: 3, offset: continueBtnOffset }}
            className="col-md-offset-right-1"
          >
            <Button
              className="float-right continueBtn ml10 w100"
              onClick={() => this.validateChartDetails("continue")}
              disabled={!dataInDateRangeAvailable && kpiAgreegateAvailable}
            >
              <span className="continueBtnTxt">
                Continue <span className="ml10 flaticon-next" />
              </span>
            </Button>
          </Col>
        </FormGroup>
        <Row className="mt40 mb20 row previewChartHeight">
          <Col sm={12} md={12} className="previewChartHeight">
            <ChartPreview
              previewOrContinue={this.state.previewOrContinue}
              emptyStateImage={this.state.emptyStateImage}
              name={chartName}
              privacy={privacy}
              kpiData={kpiData}
              benchmarkData={benchmarkData}
              startDate={startDate}
              endDate={endDate}
              chartDetails={this.props.chartDetails}
              yAxisFormat={this.yAxisFormat}
              selectedOffice={this.state.selectedOffice}
              kpiType={kpiType}
              useLatestDataAvailable={useLatestDataAvailable}
              step={chartStep.details}
              selectedKpiRecords={filteredKpiRecords}
              industriesList={industriesList}
              {...this.props}
            />
          </Col>
        </Row>
      </Form>
    );
  }
}
